import React, { useState, useEffect } from "react";
import { DynamicLink } from "../shared";
import {
  highlightBracketedText,
  highlightUnderscoreText,
} from "src/utils/utils";
import { FiArrowRight } from "react-icons/fi";

const Banner = ({ bannerCollections }: any) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 540);
    };
    
    checkMobile();
    
    window.addEventListener("resize", checkMobile);
    
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  
  const handleClose = () => {
    setIsVisible(false);
    const headerWrapper = document.querySelector('.header-wrapper') as HTMLElement;
    if (headerWrapper) {
      headerWrapper.style.top = '0';
    }
    
  };

  if (!isVisible) return null;

  // Format the title differently for mobile
  const formatTitle = (title) => {
    if (isMobile && title) {
      // Split the title at the first period
      const parts = title.split(/\.(.+)/);
      if (parts.length >= 2) {
        return (
          <>
            <span dangerouslySetInnerHTML={{ __html: highlightUnderscoreText(parts[0] + '.') }} />
            <br />
            <span dangerouslySetInnerHTML={{ __html: highlightUnderscoreText(parts[1]) }} />
          </>
        );
      }
    }
    
    return (
      <span dangerouslySetInnerHTML={{ __html: highlightUnderscoreText(title ?? "") }} />
    );
  };

  return (
    <div className="banner-wrapper">
      <div className="banner-wrapper-content">
        <div className="banner-content">
          <div className="banner-icon">
            <img
            src={bannerCollections?.icon?.url ?? ""}
            alt={bannerCollections?.icon?.title ?? ""}
            />
          </div>
          <div className="banner-text">
            {formatTitle(bannerCollections.title)}
          </div>
          <DynamicLink
            url={bannerCollections.link?.linkUrl}
            className="banner-link"
          >
            <span
              dangerouslySetInnerHTML={{
                __html: highlightBracketedText(
                  bannerCollections.link?.linkText ?? "",
                  "regular"
                ),
              }}
            />
            <FiArrowRight
              style={{ marginLeft: "5px" }}
              height={25}
              width={25}
            />
          </DynamicLink>
        </div>
        <div className="banner-actions">
          <button className="banner-close" onClick={handleClose}>
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;